import initialState from 'redux/initial-states/exportData';
import exportData from './exportData';

export default (state = initialState, action = {}) => ({
  ...state,
  ...exportData(state, action),
});
